
const primaryColor = '#1653A2';  //主题颜色
const screenWIidth = 1024;  //页面最小宽度

export {
  primaryColor,
  screenWIidth
}